import { Effect, sample } from 'effector'
import { isShowMessage, ShowError } from 'src/shared/lib/message-model/model'
import { addErrorMessage } from '@entities/error-message/model'

export function subscribeShowErrorEffect(effect: Effect<any, any, any>) {
    sample({
        clock: effect.failData.filter({ fn: isShowMessage }),
        fn: (error: ShowError) => error.showMessage,
        target: addErrorMessage
    })
}
